// frontend/src/api.js
import axios from 'axios';

const baseURL =
  process.env.REACT_APP_API_URL ||
  window.location.origin;

const api = axios.create({
  baseURL,
});
let pendingRefresh = null;

// تنظیمات پیش‌فرض
api.defaults.headers.common['Content-Type'] = 'application/json';

// --- درخواست: اضافه کردن توکن ---
api.interceptors.request.use((config) => {
  try {
    let deviceId = localStorage.getItem('esf-device-id');
    if (!deviceId && window.crypto?.randomUUID) { deviceId = window.crypto.randomUUID(); localStorage.setItem('esf-device-id', deviceId); }
    if (deviceId) config.headers['X-ESF-Device-ID'] = deviceId;
  } catch { /* Optional device recognition must not prevent requests. */ }
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // برای آپلود فایل (مثل عکس پروفایل)
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

// --- پاسخ: تمدید خودکار توکن وقتی 401 گرفت ---
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // فقط وقتی 401 گرفت و قبلاً تلاش نکرده باشیم
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry && !/\/api\/auth\/(?:login|register|verify|refresh-token)(?:\/|$|\?)/.test(originalRequest.url || '')) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem('refreshToken');

      // اگه رفرش توکن نبود → کاربر رو بنداز بیرون
      if (!refreshToken) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login_page';
        return Promise.reject(error);
      }

      try {
        // درخواست تمدید توکن
        if (!pendingRefresh) {
          pendingRefresh = axios.post(`${baseURL.replace(/\/+$/, '')}/api/auth/refresh-token`, { refreshToken }, { timeout: 15000 })
            .finally(() => { pendingRefresh = null; });
        }
        const res = await pendingRefresh;

        const { accessToken, refreshToken: newRefreshToken } = res.data;

        if (typeof accessToken !== 'string' || !accessToken) throw new Error('Invalid refresh response');
        if (localStorage.getItem('refreshToken') !== refreshToken) {
          const currentToken = localStorage.getItem('authToken');
          if (!currentToken) throw new Error('Session changed during refresh');
          originalRequest.headers = { ...originalRequest.headers, Authorization: `Bearer ${currentToken}` };
          return api(originalRequest);
        }
        localStorage.setItem('authToken', accessToken);
        if (newRefreshToken) {
          localStorage.setItem('refreshToken', newRefreshToken);
        }

        // آپدیت هدر درخواست قبلی
        originalRequest.headers = { ...originalRequest.headers, Authorization: `Bearer ${accessToken}` };

        // دوباره همون درخواست رو بزن (مثلاً دریافت قیمت، موجودی و ...)
        return api(originalRequest);

      } catch (refreshError) {
        // Offline, timeout and server errors must not destroy a valid login.
        if (refreshError.response?.status === 401 && localStorage.getItem('refreshToken') === refreshToken) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login_page';
        } else if (refreshError.response?.status === 401) {
          return Promise.reject(new Error('Session changed during refresh'));
        }
        return Promise.reject(refreshError);
      }
    }

    // اگه خطای دیگه‌ای بود، همون رو برگردون
    return Promise.reject(error);
  }
);

export default api;
